module.exports = __webpack_public_path__ + "img/3f8827009546f6c2802399f5a47008fc.svg";